var divMute = document.getElementById('mute_div');
var divPlay = document.getElementById('play_div');
if (divMute) {
    divMute.addEventListener('click', customMuteVideo);
}
if (divPlay) {
    divPlay.addEventListener('click', customPlayPauseVideo);
}
const iframes = document.getElementsByTagName('iframe');
for (const iframe of iframes) {
    const srcValue = iframe.getAttribute('src');
    const lastIndex = srcValue === null || srcValue === void 0 ? void 0 : srcValue.lastIndexOf('/');
    const trimmedURL = srcValue === null || srcValue === void 0 ? void 0 : srcValue.substring(lastIndex + 1);
    if (trimmedURL) {
        iframe.setAttribute('aria-label', trimmedURL);
    }
}
function customMuteVideo() {
    var video = document.querySelector('.video-link');
    if (video != null) {
        video.muted = !video.muted;
        divMute.innerHTML = '';
        if (video.muted) {
            divMute.innerHTML =
                '<button id="muted_button" class="customVolumeIcon fa fa-volume-off" aria-label="Attiva volume" tabindex="0"></button>';
        }
        else {
            divMute.innerHTML =
                '<button id="muted_button" class="customVolumeIcon fa fa-volume-up" aria-label="Disattiva volume" tabindex="0"></button>';
        }
    }
}
function customPlayPauseVideo() {
    var video = document.querySelector('.video-link');
    if (video != null) {
        divPlay.innerHTML = '';
        if (video.paused) {
            video.play();
            divPlay.innerHTML = '<button id="play_button" class="customVolumeIcon fa fa-pause" aria-label="Attiva riproduzione" tabindex="0"></button>';
        }
        else {
            video.pause();
            divPlay.innerHTML = '<button id="play_button" class="customVolumeIcon fa fa-play" aria-label="Disattiva riproduzione" tabindex="0"></button>';
        }
    }
}
